const DIALOG_ID = "user-selector-dialog";
const DISPLAY_ID = "js-selected-user-display";
const HIDDEN_INPUT_NAME = "user_id";
const SELECT_ROW_CLASS = "js-select-user";
const TRC_CONTAINER_ID = "js-translation-request-customers";
const TRC_CLEAR_ID = "js-trc-clear";

const loadCustomerClearButton = (element: Element | Document): void => {
  const container = element.querySelector<HTMLElement>(`#${TRC_CONTAINER_ID}`);
  const clearBtn = element.querySelector<HTMLButtonElement>(`#${TRC_CLEAR_ID}`);
  if (!container || !clearBtn) return;

  const update = (): void => {
    clearBtn.classList.toggle(
      "tw-hidden",
      !container.querySelector("input[type=checkbox]:checked")
    );
  };

  clearBtn.addEventListener("click", () => {
    container
      .querySelectorAll<HTMLInputElement>("input[type=checkbox]")
      .forEach((cb) => {
        cb.checked = false;
      });
    update();
  });

  container.addEventListener("change", update);
  update();
};

export const loadUserSelectorHandlers = (element: Element | Document): void => {
  loadCustomerClearButton(element);

  const dialog = element.querySelector<HTMLDialogElement>(`#${DIALOG_ID}`);
  if (!dialog || dialog.dataset.selectorBound) return;
  dialog.dataset.selectorBound = "true";

  const input = element.querySelector<HTMLInputElement>(
    `input[name="${HIDDEN_INPUT_NAME}"]`
  );
  const display = element.querySelector<HTMLElement>(`#${DISPLAY_ID}`);

  if (input && display) {
    input.addEventListener("input", () => {
      display.textContent = "";
    });
  }

  dialog.addEventListener("click", (e) => {
    const row = (e.target as Element).closest<HTMLElement>(
      `.${SELECT_ROW_CLASS}`
    );
    if (!row) return;

    const userId = row.dataset.userId ?? "";
    const email = row.dataset.userEmail ?? "";
    const name = row.dataset.userName ?? "";

    if (input) {
      input.value = userId;
    }
    if (display) {
      display.textContent = name ? `${email} (${name})` : email;
      display.classList.remove("tw-italic");
      display.classList.add("tw-font-medium");
      display.classList.replace("tw-text-gray-500", "tw-text-gray-700");
    }

    dialog.close();
  });
};
